// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { FormLabelComponent } from '@client/app/forms/label/label.component';
import { LabelBlockedByDomainGroupsComponent } from './modals/label-blocked-by-domain-groups-modal.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'admin-labels',
    templateUrl: './labels.component.html',
    standalone: false,
})
export class LabelsComponent extends BaseContainerComponentController implements OnInit {
    override labels: any = [];
    promise: any;
    override search: any = null;

    constructor (
        private readonly monEventService: MonEventService,
        private readonly activeFeatureService: ActiveFeatureService,
        private readonly stateService: StateService,
        private readonly monUIRouterTransitionService: MonUIRouterTransitionService,
        private readonly translateService: TranslateService,
        private readonly monModalService: MonModalService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        if (!this.activeFeatureService.isFeatureActive('labels')) {
            this.monUIRouterTransitionService.onTransitionFinished(
                () => {
                    this.stateService.go('base.dashboard');
                },
            );
            return;
        }
        this.search = null;
        this.getPage = this.loadLabels;
        this.getPage();
    }

    loadLabels (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search || null,
        };

        this.promise = this.labelRepo.getLabels(params).then((result: any) => {
            this.labels = result;
        }).catch(() => {
            // NOSONAR - Intentionally swallow error and reset to empty array
            this.labels = [];
        });
    }

    addLabel (): void {
        const params = {
            body: FormLabelComponent,
            size: 'xs',
            classes: 'fade-animation middle center label-dialog',
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: () => this.loadLabels() });
    }

    editLabel (label: any): void {
        const params = {
            body: FormLabelComponent,
            size: 'xs',
            classes: 'fade-animation middle center label-dialog',
            data: {
                label: label,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: () => this.loadLabels() });
    }

    onDelete (label: any): any {
        const confirmDeleteText = this.translateService.getString('Are you sure you want to delete label: [[label]] ?', { label: label.name });
        return this.labelRepo.getDomainGroupsUsingLabel(label.id)
            .then((res: any) => {
                if (res && res.length > 0) {
                    const params = {
                        body: LabelBlockedByDomainGroupsComponent,
                        size: 'sm',
                        classes: 'fade-animation mon-dialog-label-blocked-by-domain-groups',
                        data: {
                            label: label,
                            domains: res,
                        },
                    };
                    return this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
                } else {
                    return this.monModalService.confirm({ message: confirmDeleteText })
                        .then(() => {
                            this.onConfirmDelete(label);
                        });
                }
            });
    }

    onConfirmDelete (label: any): void {
        const params = {
            label_id: label.id,
        };
        this.labelRepo
            .deleteLabel(params)
            .then(() => {
                this.loadLabels();
            });
    }
}
